
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jargon/[slug]",
      function () {
        return require("private-next-pages/jargon/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jargon/[slug]"])
      });
    }
  